// route/PrivateRoute.jsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/DBContext';

const PrivateRoute = () => {
    const { currentUser, userInfo } = useAuth();

    if (!currentUser) {
        // User is not authenticated
        return <Navigate to="/login" />;
    }

    // If user is business or local-authority and not approved
    if (
        userInfo &&
        (userInfo.role === 'business' || userInfo.role === 'local-authority') &&
        !userInfo.approved
    ) {
        return <Navigate to="/approval-pending" />;
    }

    // User is authenticated and either approved or not a restricted role
    return <Outlet />;
};

export default PrivateRoute;
